import { CompanyFormData } from "../restaurant-equippers/restaurant-equippers.types";

export enum ArcadeGames {
  Quiz = "ARCADE-QUIZ",
  MatchUp = "ARCADE-MATCHUP",
  Puzzle = "ARCADE-PUZZLE",
  WordSearch = "ARCADE-WORD-SEARCH",
}

export enum CplStatuses {
  Accepted = "ACCEPTED",
  Denied = "DENIED",
  None = "NONE",
}

export type SweepSubmissionEntries = {
  submissionCount?: number;
  quizExtraEntries?: number;
  cplExtraEntries?: number;
  referralExtraEntries?: number;
  smsExtraEntries?: number;
};

declare abstract class Utils {
  static getHash(stringToHash: string): Promise<any>;
  static escapeRegExp(stringToEscape: string): string;
  static getCookie(cookieName: string): string | null;
}

declare abstract class LanderCplQuizUtils {
  static handleVideoAdsQuizNextSweepStep(): void;
  static handleLanderCplQuizNextSweepStep(): void;
}

declare abstract class FkcUtils {
  static skip(): void;
}

declare abstract class SnhuUtils {
  static skip(): void;
  static saveCompletionInSession(): void;
}

declare abstract class EcommerceVideoUtils {
  static skip(): void;
}

declare abstract class LyticsService {
  static landerQuizVariablesTracker(demographicQuizObj: {
    variableKey: string;
    variableValue: string | string[] | boolean;
  }): Promise<any>;
  static snhuCompletionEventTracker(): Promise<any>;
  static restaurantEquippersCompanyFormTracker(companyFormObj: CompanyFormData): Promise<any>;
}

declare abstract class RestaurantEquippersUtils {
  static handleNextSweepFlowStep(): void;
}

declare global {
  interface Theme {
    Utils: typeof Utils;
    LanderCplQuizUtils: typeof LanderCplQuizUtils;
    FkcUtils: typeof FkcUtils;
    EcommerceVideoUtils: typeof EcommerceVideoUtils;
    SnhuUtils: typeof SnhuUtils;
    LyticsService: typeof LyticsService;
    RestaurantEquippersUtils: typeof RestaurantEquippersUtils;
  }
}
